import { useState } from 'react';

import { faCircleCheck, faClipboard } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function CopyVippsBadge({ value }) {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(String(value));
            setCopied(true);

            window.setTimeout(() => {
                setCopied(false);
            }, 1600);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error('Kunne ikke kopiere Vippsnummer:', err);
        }
    };

    return (
        <button
            type="button"
            className={`vipps-badge ${copied ? 'is-copied' : ''}`}
            onClick={handleCopy}
            aria-label={
                copied ? 'Vippsnummer kopiert til utklippstavlen' : `Kopier Vippsnummer ${value}`
            }
            title={copied ? 'Kopiert' : 'Klikk for å kopiere Vippsnummer'}
        >
            <FontAwesomeIcon
                icon={copied ? faCircleCheck : faClipboard}
                className="vipps-badge__icon"
            />
            <span>{copied ? 'Kopiert' : `Vipps #${value}`}</span>
        </button>
    );
}

export default CopyVippsBadge;
